import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VBtn,{directives:[{name:"show",rawName:"v-show",value:(_vm.GET_COTACOES_ID_PEDIDO.length > 0),expression:"GET_COTACOES_ID_PEDIDO.length > 0"}],staticStyle:{"margin-top":"0.4em"},attrs:{"color":"primary","dark":""},on:{"click":function($event){return _vm.abrirDialogCotacaoPedido()}}},[_vm._v("\n    Ver cotações\n  ")]),_c('Cotacao',{attrs:{"pedido":_vm.pedido,"ativacao_dialog_personalizada":"ver"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }